import React from 'react';

import { useTranslation } from 'react-i18next';

import bg from '@assets/images/nomad/nomad-bonus-banner-logged.png';

import * as Styled from './banner.styled.ts';

const Banner = () => {
	const { t } = useTranslation('main');

	return (
		<Styled.Wrapper>
			<Styled.Title>{t('nomadHomeTitle')}</Styled.Title>
			<Styled.BgImage src={bg} alt='banner' />
		</Styled.Wrapper>
	);
};
export default Banner;
